import React, { useEffect, useState } from 'react'
import { getCheckout } from '../Redux/ActionCreator/CheckoutActionCreator'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import UserSidebar from './Partial/UserSidebar'
import Menubar from './Partial/Menubar'

export default function Order() {
    let [order, setOrder] = useState([])
    let dispatch = useDispatch()


    let CheckoutStateData = useSelector(state => state.CheckoutStateData)

    useEffect(() => {
        (() => {
            dispatch(getCheckout())
            if (CheckoutStateData.length) {
                setOrder(CheckoutStateData);
            }
            else
                setOrder([])
        })()

    }, [CheckoutStateData.length])

    return (
        <>
            <Menubar title="History Page" />
            <div className="container mt-4">
                <div className="row">
                    <div className="col-md-3">
                        <UserSidebar />
                    </div>
                    <div className="col-md-9">
                        <div className="testimonial-item img-border-radius shadow-sm bg-white mb-2">
                            <h5 className='px-4 py-3'>My Order History</h5>
                        </div>
                        <div>
                            {
                                order.length === 0 ?
                                    <div className='text-center mt-5'>
                                        <p className='text-dark'>You haven't ordered anything yet!!!</p>
                                        <Link className='btn btn-info' to="/shop">Shop Now</Link>
                                    </div>
                                    :
                                    order.map((item, index) => (
                                        <div key={index}>
                                            <div className="testimonial-item img-border-radius shadow-sm bg-white mb-2 p-2">
                                                <div className='float-end me-4'>
                                                    <Link className='border-bottom' style={{ fontSize: "14px" }} to={`/order_detail/${item._id}`}><i className='fa fa-eye'></i></Link>
                                                </div>
                                                {item.products.map((product, idx) => (
                                                    <div key={idx} className="row md-ps-4">
                                                        <div className="col-md-2 col-6 mb-1">
                                                            <img src={`/${product.product?.pic}`} height={100} width="100%" alt="" />
                                                        </div>
                                                        <div className='col-12 col-md-10'>
                                                            <span>{product.product?.name?.slice(0, 15) + "..."}<span className='border rounded-pill px-2 mx-2' style={{ fontSize: "12px" }}>Brand: {product.product?.brand?.name}</span></span>
                                                            <div className='d-flex gap-1'>
                                                            </div>
                                                            <p className='extra'>&#8377; {product.total}</p>
                                                            <p className='text-success extra'>{item.orderStatus}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}

